(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 1099px)');
  var DRAWER_ANIM_MS = 380;

  function initMobileHeader() {
    var icons = document.querySelector('.header__icons');
    var header = document.querySelector('.header');
    var navSlot = document.querySelector('[data-tt-nav-icons]');
    if (!icons || !header || !navSlot) return;

    function layout() {
      if (MOBILE_MQ.matches) {
        if (icons.parentElement !== navSlot) {
          navSlot.appendChild(icons);
        }
        icons.classList.add('tt-nav__icons');
        document.documentElement.classList.add('tt-mobile-header');
      } else {
        if (icons.parentElement !== header) {
          header.appendChild(icons);
        }
        icons.classList.remove('tt-nav__icons');
        document.documentElement.classList.remove('tt-mobile-header');
      }
    }

    layout();
    MOBILE_MQ.addEventListener('change', layout);
  }

  function initNav(root) {
    if (!root || root.dataset.ttMobileNavInit) return;
    root.dataset.ttMobileNavInit = 'true';

    var drawer = root.querySelector('[data-tt-nav-drawer]');
    var openBtn = root.querySelector('[data-tt-nav-open]');
    if (!drawer || !openBtn) return;

    var panel = drawer.querySelector('.tt-nav__drawer-panel');
    drawer.classList.add('tt-nav__drawer--portal');
    document.body.appendChild(drawer);

    var closeEls = drawer.querySelectorAll('[data-tt-nav-close]');
    var accordionBtns = drawer.querySelectorAll('[data-tt-nav-accordion]');
    var closeTimer = null;

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeAccordions() {
      accordionBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var subPanel = btn.nextElementSibling;
        if (subPanel) subPanel.classList.remove('is-open');
      });
    }

    function setOpen(open) {
      clearCloseTimer();
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('tt-nav-scroll-lock', open);
      root.classList.toggle('is-drawer-open', open);

      if (open) {
        drawer.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add('is-drawer-open');
        });
        return;
      }

      drawer.classList.remove('is-drawer-open');
      closeAccordions();
      closeTimer = setTimeout(function () {
        if (!drawer.classList.contains('is-drawer-open')) {
          drawer.hidden = true;
        }
      }, DRAWER_ANIM_MS);
    }

    openBtn.addEventListener('click', function () {
      setOpen(true);
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.matches('[data-tt-nav-close]')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-drawer-open')) {
        setOpen(false);
        openBtn.focus();
      }
    });

    if (panel) {
      panel.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'transform') return;
        if (!drawer.classList.contains('is-drawer-open')) {
          drawer.hidden = true;
          clearCloseTimer();
        }
      });
    }

    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var subPanel = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (subPanel) subPanel.classList.toggle('is-open', !expanded);
      });
    });

    drawer.querySelectorAll('.tt-nav__drawer-sub a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });
  }

  function boot() {
    initMobileHeader();
    document.querySelectorAll('[data-tt-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
